import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Experiences", path: "/experiences" },
  { label: "Gallery", path: "/gallery" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#FAF8F5] shadow-sm" : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-8 md:px-16 h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img
            src="https://static.readdy.ai/image/95b9eb99ec7b07a75e7e9971f3e8aa69/162509367b0586d9654593ed349a2eeb.png"
            alt="Table Privé"
            className="h-10 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={`font-light tracking-[0.15em] text-sm uppercase transition-colors duration-300 cursor-pointer ${
                  scrolled
                    ? location.pathname === link.path
                      ? "text-[#1A1A1A]"
                      : "text-[#8A7F74] hover:text-[#1A1A1A]"
                    : location.pathname === link.path
                    ? "text-white"
                    : "text-white/70 hover:text-white"
                }`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Desktop CTA */}
        <Link
          to="/inquiry"
          className={`hidden md:inline-flex items-center gap-2 tracking-[0.2em] text-[11px] uppercase font-light transition-colors duration-300 cursor-pointer whitespace-nowrap border-b pb-0.5 ${
            scrolled
              ? "text-[#8A7F74] border-[#8A7F74]/30 hover:text-[#1A1A1A] hover:border-[#1A1A1A]/50"
              : "text-white/60 border-white/20 hover:text-white hover:border-white/50"
          }`}
        >
          Private Inquiry
        </Link>

        {/* Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex flex-col items-center justify-center gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-px transition-all duration-300 ${scrolled ? "bg-[#1A1A1A]" : "bg-white"} ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`block w-6 h-px transition-all duration-300 ${scrolled ? "bg-[#1A1A1A]" : "bg-white"} ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`block w-6 h-px transition-all duration-300 ${scrolled ? "bg-[#1A1A1A]" : "bg-white"} ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-500 overflow-hidden bg-[#FAF8F5] ${
          menuOpen ? "max-h-80 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <ul className="flex flex-col px-8 py-6 gap-6">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className="font-light tracking-[0.15em] text-sm uppercase text-[#8A7F74] hover:text-[#1A1A1A] transition-colors cursor-pointer"
              >
                {link.label}
              </Link>
            </li>
          ))}
          <li>
            <Link
              to="/inquiry"
              className="inline-flex items-center px-6 py-2.5 border border-[#1A1A1A] text-[#1A1A1A] tracking-[0.12em] text-xs uppercase font-light cursor-pointer whitespace-nowrap"
            >
              Private Inquiry
            </Link>
          </li>
        </ul>
      </div>
    </header>
  );
}
